import api from "../../api.service";
import Swal from "sweetalert2";
import store from "../";

const state = {
    adList: [],
    adsListNotFilterd: [],
    today: new Date(),
    currentAd: {
        id: 0,
        cityId: 0,
        cityName: "",
        description: "",
        endDate: new Date().toISOString().substr(0, 10),
        adDates: [new Date().toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)],
        image: [],
        shopId: 0,
        shopName: "",
        startDate: new Date().toISOString().substr(0, 10),
        type: 1
    }
};
const getters = {
    adList(state) {
        return state.adList;
    },
    currentAd(state) {
        return state.currentAd;
    },
    adsListNotFilterd(state) {
        return state.adsListNotFilterd
    }
};
const mutations = {
    GET_AD_ITEMS(state, payload) {
        state.adsListNotFilterd = payload.map((item) => {
            item.image = [item.image]
            return item;
        });
        state.adList = state.adsListNotFilterd.filter((ad) => {
            return ad.type == 1
        })
        store.dispatch('setLoading', false);
    },
    GET_CURRENT_AD_ITEMS(state, payload) {
        if (state.adList.length) {
            Object.assign( state.currentAd,state.adList[payload]);
                state.currentAd.adDates = [new Date(state.currentAd.startDate).toISOString().substr(0, 10),
                    new Date(state.currentAd.endDate).toISOString().substr(0, 10)];
        } else {
            const adsInterval = setInterval(() => {
                if (state.adList.length) {
                    Object.assign( state.currentAd,state.adList[payload]);
                    state.currentAd.adDates = [new Date(state.currentAd.startDate).toISOString().substr(0, 10),
                        new Date(state.currentAd.endDate).toISOString().substr(0, 10)];
                    clearInterval(adsInterval);
                }
            }, 500);
        }
    },
    ADD_AD_ITEMS(state, payload) {
        console.log(payload);
        if (typeof payload == "string") {
            store.dispatch('setLoading', false);
            Swal.fire({
                title: "إضافة عرض غير ممكنة",
                text: `${payload}.`,
                icon: "warning",
                confirmButtonText: "تم"
            });
        } else {
            payload.image = [payload.image]
            state.adList.unshift(payload);
            Swal.fire({
                title: "تمت الإضافة بنجاح",
                icon: "success",
                confirmButtonText: "تم"
            });
            state.currentAd = {
                cityId: 0,
                cityName: "",
                description: "",
                endDate: new Date().toISOString().substr(0, 10),
                id: 0,
                image: [],
                adDates: [new Date().toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)],
                shopId: 0,
                shopName: "",
                startDate: new Date().toISOString().substr(0, 10),
                type: 1
            }
            store.dispatch('setLoading', false);
        }
    },
    UPDATE_AD_ITEMS(state, payload) {
        if (typeof payload == "string") {
            store.dispatch('setLoading', false);
            Swal.fire({
                title: "تعديل العرض غير ممكن",
                text: `${payload}.`,
                icon: "warning",
                confirmButtonText: "تم"
            });
        } else {
            let ad = state.adList.findIndex(item => item.id == payload.id);
            payload.image = [payload.image]
            Object.assign(state.adList[ad], payload);
            Swal.fire({
                title: "تم التعديل بنجاح",
                icon: "success",
                confirmButtonText: "تم"
            });
            state.currentAd = {
                cityId: 0,
                cityName: "",
                description: "",
                endDate: new Date().toISOString().substr(0, 10),
                id: 0,
                image: [],
                adDates: [new Date().toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)],
                shopId: 0,
                shopName: "",
                startDate: new Date().toISOString().substr(0, 10),
                type: 1
            }
            store.dispatch('setLoading', false);
        }
    },
    DELETE_AD_ITEMS(state, payload) {
        const index = state.adList.findIndex(
            item => item.id == payload.id
        );
        state.adList.splice(index, 1);
        Swal.fire({
            title: "تم الحذف !",
            text: `تم حذف إعلان.`,
            icon: "success",
            confirmButtonText: "تم"
        });
    },
    RESET_AD_DTO(state) {
        state.currentAd = {
            cityId: 0,
            cityName: "",
            description: "",
            endDate: new Date().toISOString().substr(0, 10),
            id: 0,
            image: [],
            adDates: [new Date().toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)],
            shopId: 0,
            shopName: "",
            startDate: new Date().toISOString().substr(0, 10),
            type: 1
        }
    },
    FILTER_ADS_TABS(state, type){
        state.adList = state.adsListNotFilterd.filter((ad) => {
            return ad.type == type
        })
    }
};

const actions = {
    async fetchAd(context) {
        store.dispatch('setLoading', true);
        const { data } = await api
            .query(`/api/Ad/GetAds`)
            .then(data => data);
        context.commit("GET_AD_ITEMS", data);
    },
    async deleteAd(context, payload) {
        await api
            .delete(`/api/Ad/RemoveAd?adId=${payload.id}`)
            .then(data => data);
        context.commit("DELETE_AD_ITEMS", payload);
    },
    async setAd(context, payload) {
        store.dispatch('setLoading', true);
        var type;
        console.log(payload)
        console.log(payload.type)
        if(payload.type == "2"){
            console.log("dasfdgh2")
            type = 2;
        }
        else if(payload.type == "1"){
            console.log("dasfdgh1")
            type = 1;
        }
        const { data } = await api
            .post("/api/Ad/SetAd", {
                Id: payload.id,
                CityId: payload.cityId,
                StartDate: payload.adDates[0],
                EndDate: payload.adDates[1],
                Image: payload.image[0],
                ShopId: payload.shopId,
                Type: type,
                Description: payload.description
            })
            .then(data => data);
        if (payload.id == 0) {
            context.commit("ADD_AD_ITEMS", data);
        } else {
            context.commit("UPDATE_AD_ITEMS", data);
        }
    },
    fetchCurrentAd(context, payload) {
        context.commit("GET_CURRENT_AD_ITEMS", payload);
    },
    resetAdDto(context) {
        context.commit('RESET_AD_DTO')
    },
    filterAds(context, type) {
        context.commit('FILTER_ADS_TABS', type)
    },
    setAdType(context , type){
        state.currentAd.type = type;
    }
};

const adManegment = {
    state,
    getters,
    actions,
    mutations
};
export default adManegment;
